import { useStore } from '@/store/bucket'

/**
 * ブランド・ストア情報がstoreに格納されていない場合、    
 * ブランド・ストア情報を取得し、storeに渡す処理（各ページで実行）
 * @param {Object} pref ブランド・ストアなどの情報（props.pref）
 */

// ブランド情報・ストア情報がstoreに格納されていない場合、prefを取得し、storeに渡す処理（各ページで実行）
export default function usePref(pref){
  const store = useStore()

  if(!store.getBrandList.length){
    store.updateBrandList(pref.brands)
  }
  
  if(!store.getShopList.length){
    store.updateShopList(pref.shops)
  }
}
